import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { StaffSyncReport } from '../../_models/admin/staff-sync.models';
import { StaffSyncService } from '../../_services/staff-sync/staff-sync.service';
import { AdminEmailComponent } from '../../shared/admin-ux/admin-email.component';

/**
 * Read-only report of the Orbit → LEAP staff sync: when it last ran, what it did, the LEAP-only staff it
 * left alone and the conflicts it skipped. Lives on the Sync tab of New Features, under the switch rows.
 */
@Component({
  selector: 'staff-sync-panel',
  standalone: true,
  imports: [DatePipe, AdminEmailComponent],
  templateUrl: 'staff-sync-panel.component.html'
})
export class StaffSyncPanelComponent implements OnInit {

  public report: StaffSyncReport = null;
  public loading = false;
  public error: string = null;

  constructor(private service: StaffSyncService) { }

  ngOnInit(): void {
    this.load();
  }

  public load(): void {
    this.loading = true;
    this.error = null;
    this.service.getReport().subscribe({
      next: report => {
        this.loading = false;
        this.report = report || { switchEnabled: false, lastRun: null };
      },
      error: error => {
        this.loading = false;
        this.error = (error && error.message) || 'Could not load the staff sync report.';
      }
    });
  }

  /** The counts in display order. */
  public counts(): { label: string, value: number, test: string }[] {
    const run = this.report && this.report.lastRun;
    if (!run) {
      return [];
    }
    return [
      { label: 'Pulled from Orbit', value: run.pulled, test: 'pulled' },
      { label: 'Created', value: run.created, test: 'created' },
      { label: 'Linked', value: run.linked, test: 'linked' },
      { label: 'Updated', value: run.updated, test: 'updated' },
      { label: 'Deactivated', value: run.deactivated, test: 'deactivated' },
      { label: 'Skipped (no TM role)', value: run.skipped, test: 'skipped' },
      { label: 'Conflicts', value: run.conflicts, test: 'conflicts' },
      { label: 'TM-only staff', value: run.leapOnly, test: 'leapOnly' }
    ];
  }

  public fullName(first: string | null, last: string | null): string {
    return [first, last].filter(p => !!p).join(' ') || '(no name)';
  }
}
